import { render, staticRenderFns } from "./DepositoCategoriaFormDialog.vue?vue&type=template&id=9893372e"
import script from "./DepositoCategoriaFormDialog.vue?vue&type=script&lang=js"
export * from "./DepositoCategoriaFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports